// Client-side route gate. Returns the user if allowed; otherwise navigates and returns null.
// Use inside route components: `const user = useRequireRole(['superadmin'])`.
import { useEffect, useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { getSession, getUser, loginForRole, homeForRole, useMockAuth, type Role, type MockUser } from "@/lib/mock-auth";

export function useRequireRole(allowed: Role[]): MockUser | null {
  const navigate = useNavigate();
  const { ready } = useMockAuth();
  const [user, setUser] = useState<MockUser | null>(null);

  useEffect(() => {
    if (!ready) return;
    const s = getSession();
    if (!s) {
      navigate({ to: loginForRole(allowed[0]), replace: true });
      return;
    }
    if (!allowed.includes(s.role)) {
      navigate({ to: homeForRole(s.role), replace: true });
      return;
    }
    setUser(getUser(s.userId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready]);

  return user;
}
